module.exports = __webpack_public_path__ + "img/waxart_5haqw.wam.16d2351.png";